/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Summary_CreatedInputs */

const cs_ebr_summary_created = /** @type {(inputs: Ebr_Summary_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno`)
};

const en_ebr_summary_created = /** @type {(inputs: Ebr_Summary_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Ebr_Summary_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_summary_created = /** @type {((inputs?: Ebr_Summary_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Summary_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_summary_created(inputs)
	return cs_ebr_summary_created(inputs)
});